module.exports = __webpack_public_path__ + "7f84cd22a123fb4422c48aee891458e8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/2_C#2.mp3
// module id = 118
// module chunks = 0